module.exports = __webpack_public_path__ + "media/images/logos/cronofy-logo-b9b8347d540963639eeec57c8964b480.png";